import { Colors } from '../../theme'

export default {
  fontSize: '1.1rem',
  backgroundColor: Colors.Palette.whiteColor,
  fontWeight: 400,
  color: '#353635',
  textTransform: 'none',
  overflow: 'visible',
  width: 240,
  textAlign: 'center',
  '&.active': {
    color: Colors.Palette.primaryColor
  }
}



// WEBPACK FOOTER //
// ./src/styles/tabs/main.js